import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseEditService } from './base-edit.service';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseEditCreateService<T, TEdit> extends BaseEditService<T, TEdit> {
  protected constructor(baseRoute: string, name: string) {
    super(baseRoute, name);
  }

  create(parentId?: string, parentId2?: string): Observable<TEdit> {
    return this.httpService.get<TEdit>(
      `${this.apiUrl}/Create${parentId ? `/${parentId}` : ''}${parentId2 ? `/${parentId2}` : ''}`,
    );
  }
}
